export default __webpack_public_path__ + "static/media/tilda-logo.80569c55.png";